import { Quote } from "lucide-react";
import StarRating from "./StarRating";

// Marquee reviews slider — doubles the array for seamless loop.
const ReviewsSlider = ({ reviews = [], testId = "reviews-slider" }) => {
  if (!reviews.length) return null;
  const doubled = [...reviews, ...reviews];

  return (
    <div data-testid={testId} className="relative overflow-hidden">
      <div
        className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10"
        style={{
          background:
            "linear-gradient(to right, var(--adhd-bg), transparent)",
        }}
      />
      <div
        className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10"
        style={{
          background:
            "linear-gradient(to left, var(--adhd-bg), transparent)",
        }}
      />
      <div className="adhd-marquee flex gap-6 w-max">
        {doubled.map((r, i) => (
          <article
            key={`${r.name}-${i}`}
            data-testid={`review-card-${i}`}
            className="adhd-card relative w-[320px] sm:w-[380px] p-7 flex flex-col gap-4"
          >
            <Quote
              size={28}
              className="opacity-20"
              style={{ color: "var(--adhd-primary)" }}
            />
            <p className="text-[15px] leading-relaxed text-[color:var(--adhd-text)]">
              "{r.text}"
            </p>
            <div className="flex items-center justify-between mt-2 pt-4 border-t border-[color:var(--adhd-border)]">
              <div>
                <p className="font-semibold text-sm text-[color:var(--adhd-text)]">
                  {r.name}
                </p>
                <p className="text-xs text-[color:var(--adhd-muted)]">{r.role}</p>
              </div>
              <StarRating rating={5} size={13} />
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default ReviewsSlider;
